import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class InventoryAdjustmentStyles extends CommonComponentStyle {
  FieldRowWrapper = styled(Grid)`
    padding: 12px;
    width: 150px;
  `;

  FieldErrorRowWrapper = styled(Grid)`
    padding: 0 12px 12px 12px;
    width: 150px;
  `;

  InventoryDetailButton = styled(this.SecondaryButton)`
    width: 100% !important;
    padding: 6px 4px !important;
  `;

  AddItemButton = styled(this.SecondaryButton)`
    width: 100% !important;
  `;

  RemoveButton = styled(this.RedButtonText)`
    font-size: 14px !important;
  `;

  CompleteButton = styled(this.PrimaryButton)`
    width: 100% !important;
  `;

  StickyFooterWrapper = styled(this.FooterWrapper)`
    position: sticky;
  `;
}

export const InventoryAdjustmentStyle = new InventoryAdjustmentStyles();
